import { useIsFeatureEnabled } from '@innovyze/stylovyze';

// Single flag name for the whole risk redesign (epic I360A-2067), so every
// later slice gates on the same switch instead of inventing its own string.
const RISK_TEMPLATES_FLAG = 'info-360-asset-risk-templates';

export const useIsRiskTemplatesEnabled = (): boolean =>
	Boolean(useIsFeatureEnabled(RISK_TEMPLATES_FLAG));
